import createIcon from '../../createIcon';

/**
 * @component @name SportsBaseball
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy44MSA2LjI4QzIuNjcgNy45IDIgOS44NyAyIDEyQzIgMTQuMTMgMi42NyAxNi4xIDMuODEgMTcuNzJDNi4yMyAxNi45NSA4IDE0LjY4IDggMTJDOCA5LjMyIDYuMjMgNy4wNSAzLjgxIDYuMjhaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjAuMTkgNi4yOEMxNy43NyA3LjA1IDE2IDkuMzIgMTYgMTJDMTYgMTQuNjggMTcuNzcgMTYuOTUgMjAuMTkgMTcuNzJDMjEuMzMgMTYuMSAyMiAxNC4xMyAyMiAxMkMyMiA5Ljg3IDIxLjMzIDcuOSAyMC4xOSA2LjI4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE0IDEyQzE0IDguNzIgMTUuOTcgNS45MSAxOC43OSA0LjY3QzE3LjAxIDMuMDIgMTQuNjMgMiAxMiAyQzkuMzcgMiA2Ljk5IDMuMDIgNS4yMSA0LjY3QzguMDMgNS45MSAxMCA4LjcyIDEwIDEyQzEwIDE1LjI4IDguMDMgMTguMDkgNS4yMSAxOS4zM0M2Ljk5IDIwLjk4IDkuMzcgMjIgMTIgMjJDMTQuNjMgMjIgMTcuMDEgMjAuOTggMTguNzkgMTkuMzNDMTUuOTcgMTguMDkgMTQgMTUuMjggMTQgMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SportsBaseball = createIcon('SportsBaseball', [
  [
    'path',
    {
      d: 'M3.81 6.28C2.67 7.9 2 9.87 2 12C2 14.13 2.67 16.1 3.81 17.72C6.23 16.95 8 14.68 8 12C8 9.32 6.23 7.05 3.81 6.28Z',
      key: 'wvsfwj',
    },
  ],
  [
    'path',
    {
      d: 'M20.19 6.28C17.77 7.05 16 9.32 16 12C16 14.68 17.77 16.95 20.19 17.72C21.33 16.1 22 14.13 22 12C22 9.87 21.33 7.9 20.19 6.28Z',
      key: '1ic1l3',
    },
  ],
  [
    'path',
    {
      d: 'M14 12C14 8.72 15.97 5.91 18.79 4.67C17.01 3.02 14.63 2 12 2C9.37 2 6.99 3.02 5.21 4.67C8.03 5.91 10 8.72 10 12C10 15.28 8.03 18.09 5.21 19.33C6.99 20.98 9.37 22 12 22C14.63 22 17.01 20.98 18.79 19.33C15.97 18.09 14 15.28 14 12Z',
      key: '14appk',
    },
  ],
]);

export default SportsBaseball;
